<template>
  <v-dialog width="80vw" :value="value" @input="toggleModal()" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbPink" dark flat>
        <div class="text-h6">{{ $t('general.editPeopleInBlock') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <v-row>
          <v-col sm="12" md="6" lg="3" class="align-center">
            <v-checkbox color="kbDarkBlue"
                        :label="$t('general.changeExtraData')"
                        v-model="typeOfEditing.extraData"/>
          </v-col>
          <v-col sm="12" md="6" lg="3" class="align-center">
            <v-checkbox color="kbDarkBlue"
                        :label="$t('general.changeJourneyCurrentStatus')"
                        v-model="typeOfEditing.journey"/>
          </v-col>
          <v-col sm="12" md="6" lg="3" class="align-center">
            <v-checkbox color="kbDarkBlue"
                        :label="$t('general.createTask')"
                        v-model="typeOfEditing.task"/>
          </v-col>
          <v-col sm="12" md="6" lg="3" class="align-center"  v-if="Array.isArray(administrators) && administrators.length > 0" >
            <v-checkbox color="kbDarkBlue"
                        :label="$t('general.editResponsible')"
                        v-model="typeOfEditing.responsible"/>
          </v-col>

          <v-col cols="12"
                 v-show="!areTypesOfEditingSelected">
            <div class="d-flex flex-column justify-center align-center" style="height: 40vh">
              <v-icon color="kbDarkBlueText" size="80px">mdi-checkbox-multiple-marked</v-icon>
              <p class="kbGray--text text-center mt-4"
                 style="font-size: 18px; max-width: 50%">
                {{ $t('general.chooseTheTypeOfBlockEdition') }}
              </p>
            </div>
          </v-col>

          <v-col cols="12" v-show="typeOfEditing.extraData">
            <v-card color="kbWhite">
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="d-flex justify-space-between align-center pb-4">
                    <span class="kbDarkBlue--text"
                          style="font-size: 24px">
                      {{ $t('general.modifyTheAdditionalDataThatYouWant') }}
                    </span>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <p class="kbGrayText--text">
                      {{ `${$t('general.note')}: ${$t('general.justTheFilledExtraDataAreGoingToBeChanged')}` }}
                    </p>
                  </v-col>
                  <v-col cols="12"
                         md="6"
                         v-for="(extraData, index) in extraDatas"
                         :key="index">
                    <span class="kbDarkBlue--text mb-1 text-capitalize">
                      {{ extraData.name }}
                    </span>
                    <InlineEditor :field-type="extraData.type || 'text'"
                                  :label="extraData.name"
                                  :options="extraData.options"
                                  option-label="name"
                                  option-value="name"
                                  :value="extraData.value"
                                  @onSave="changeExtraData(index, $event)">
                      <span>{{ extraData  | extraDataAppearance }}</span>
                    </InlineEditor>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" v-if="typeOfEditing.journey">
            <v-card color="kbWhite">
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <span class="kbDarkBlue--text"
                          style="font-size: 24px">
                      {{ $t('general.pickTheJourneyStatusToAssignInBlock') }}
                    </span>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <UserJourney isBlockEdition @onJourneyChange="onJourneyChange($event)"/>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" v-if="typeOfEditing.task">
            <AddNewTask cardColor="kbWhite"
                        inputsBackgroundColor="kbLight"
                        extraStep
                        :title="$t('general.createNewTaskToAssignInBlock')"
                        @onNewTaskSaved="onNewTaskSaved($event)" />
          </v-col>

          <v-col cols="12" v-if="typeOfEditing.responsible">
            <v-card color="kbWhite">
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <span class="kbDarkBlue--text"
                          style="font-size: 24px; margin: auto;">
                      {{ $t('general.selectResponsibleSolo') }}
                    </span>
                  </v-col>
                  <v-col cols="12" class="mt-5 text-center ">
                    <v-autocomplete
                      color="kbDarkBlueText"
                      :items="administrators"
                      item-text="fullName"
                      item-value="userId"
                      :label="$t('general.pickAResponsible')"
                      outlined
                      style="max-width: 500px; margin: auto;"
                      v-model="responsibleId"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2"
               color="red"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn :color="areTypesOfEditingSelected ? 'kbPink' : 'kbGrayLightText'"
               :style="{ cursor: areTypesOfEditingSelected ? 'pointer' : 'default' }"
               dark
               :loading="loadingBlockUpdate"
               @click="updateUsersInBlocks()">
          {{ $t('general.editInBlock') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
import UserJourney from '@/pages/App/People/dialogs/ViewUser/UserJourney'
import AddNewTask from '@/pages/App/People/dialogs/ViewUser/Tasks/AddNewTask'
import PeopleMixin from '@/mixins/PeopleMixin'

export default {
  components: { AddNewTask, UserJourney },
  mixins: [PeopleMixin],
  computed: {
    ...mapGetters(['appUuid', 'companyUuid', 'administrators']),
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas
    }),
    areTypesOfEditingSelected () {
      return (this.typeOfEditing.extraData || this.typeOfEditing.journey || this.typeOfEditing.task || this.typeOfEditing.responsible)
    },
    dataValidationBeforeEditingInBlock () {
      const filteredExtraData = this.extraDatas.filter(item => item.value)
      if (this.typeOfEditing.extraData && filteredExtraData.length === 0) return { isEditionValid: false, message: this.$t('general.modifyAtLeastOneExtraDataToEditInBlock') }
      if (this.typeOfEditing.journey && !this.selectedJourneyId.toString()) return { isEditionValid: false, message: this.$t('general.addAJourneyStatusToEditInBlock') }
      if (this.typeOfEditing.task && (!this.newTask ||
          typeof this.newTask !== 'object' ||
          Object.keys(this.newTask).length === 0)) return { isEditionValid: false, message: this.$t('general.createAValidTaskToAddInBlock') }
      return { isEditionValid: true }
    }
  },
  data () {
    return {
      extraDatas: [],
      loadingBlockUpdate: false,
      newTask: {},
      selectedJourneyId: '',
      responsibleId: '',
      typeOfEditing: {
        extraData: false,
        journey: false,
        task: false,
        responsible: false
      }
    }
  },
  methods: {
    changeExtraData (index, value) {
      this.extraDatas[index].value = value
    },
    clearLocalExtraData () {
      this.extraDatas = []
    },
    onJourneyChange (journeyId) {
      this.selectedJourneyId = journeyId
    },
    onNewTaskSaved (task) {
      this.newTask = task
    },
    populateLocalExtraData () {
      this.extraDatas = [...this.appCustomExtradatas.map(item => ({ ...item, value: '' }))]
    },
    resetTypeOfEditing () {
      this.typeOfEditing = {
        extraData: false,
        journey: false,
        task: false
      }
    },
    toggleModal () {
      this.$emit('input', false)
    },
    async updateUsersInBlocks () {
      if (this.loadingBlockUpdate) return
      if (!this.areTypesOfEditingSelected) return notifications.error(this.$t('general.pickAtLeastOneTypeOfEditingToEditInBlock'))
      if (!this.dataValidationBeforeEditingInBlock.isEditionValid) return notifications.error(this.dataValidationBeforeEditingInBlock.message)
      const requests = []
      if (this.typeOfEditing.extraData) requests.push(this.updateExtraDataInBlock())
      if (this.typeOfEditing.journey) requests.push(this.updateJourneyStatusInBlock())
      if (this.typeOfEditing.task) requests.push(this.createTaskInBlock())
      if (this.typeOfEditing.responsible) requests.push(this.changeUserResponsibleInBlock())
      try {
        this.loadingBlockUpdate = true
        await Promise.all(requests)
        await this.$emit('getUsers')
        this.loadingBlockUpdate = false
        notifications.success(this.$t('general.editInBlockFinishedSuccessfully'))
        this.toggleModal()
      } catch (e) {
        this.loadingBlockUpdate = false
        notifications.error(e)
      }
    },
    async updateExtraDataInBlock () {
      let filteredExtraData = this.extraDatas.filter(item => item.value)
      filteredExtraData = filteredExtraData.map(item => ({ field: item.name, value: item.value, access: 'app', idExtraCustom: null }))
      await this.$store.dispatch('changeOrAddExtraDataInBlock', {
        appId: this.appUuid,
        companyId: this.companyUuid,
        data: { extradata: filteredExtraData, usersIds: this.usersIds }
      })
    },
    async updateJourneyStatusInBlock () {
      await this.$store.dispatch('changeUsersJourneyInBlock', {
        appId: this.appUuid,
        companyId: this.companyUuid,
        data: { journeyId: this.selectedJourneyId, usersIds: this.usersIds }
      })
    },
    async createTaskInBlock () {
      await this.$store.dispatch('createNewTaskInBlock', {
        appId: this.appUuid,
        companyId: this.companyUuid,
        data: { task: this.newTask, usersIds: this.usersIds }
      })
    },
    async changeUserResponsibleInBlock () {
      await this.$store.dispatch('changeUserResponsibleInBlock', {
        appId: this.appUuid,
        companyId: this.companyUuid,
        data: { responsibleId: this.responsibleId, usersIds: this.usersIds }
      })
    }
  },
  props: {
    usersIds: {
      type: Array,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (newValue) {
      if (!newValue) {
        this.clearLocalExtraData()
        this.resetTypeOfEditing()
      } else {
        this.populateLocalExtraData()
      }
    }
  }
}
</script>

<style scoped>
  .edit-in-block-card {
    background-color: white;
    border-radius: 10px;
    height: 90vh;
    overflow: hidden;
  }
</style>
